// extracted by mini-css-extract-plugin
module.exports = {"PostMenuTrigger":"oy_a bhb_i bhb_j bhb_q bhb_un bhb_wf bhb_en"};